import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import MyIcon from 'components/Icon';
import { variables } from 'components/Theme';
import Truncate from 'components/Truncate';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { URL_SELECT } from 'settings';

import type { DispatchProp } from 'react-redux';

const styles = withStyles((theme) => ({
  cardContainer: {
    border: `1px solid ${variables.palette.grey[100]}`,
    borderRadius: theme.shape.borderRadius,
    textAlign: 'center',
    paddingBottom: theme.spacing(1),
    transition: 'background-color, box-shadow, 0.2s',
    backgroundColor: 'white',
    height: '100%',
    '&:hover': {
      backgroundColor: variables.palette.grey[50],
      boxShadow: variables.shadows[1],
      cursor: 'pointer',
      transition: 'background-color 0.2s, box-shadow 0.3s',
    },
  },
  cardImage: {
    width: 150,
    maxWidth: '100%',
    height: 150,
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
    overflow: 'hidden',
    '& > img': {
      borderRadius: theme.shape.borderRadius,
      width: '100%',
    },
  },
  cardTitle: {
    color: variables.palette.primary.main,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.3,
    fontWeight: 400,
    padding: `${theme.spacing(2) / 2}px ${theme.spacing(1)}px`,
    paddingTop: 0,
    '& > div': {
      minHeight: 36,
      maxHeight: 36,
    },
  },
  cardAuthor: {
    color: variables.palette.grey[400],
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.3,
    fontWeight: 400,
    padding: `${theme.spacing(2) / 2}px ${theme.spacing(4)}px`,
    paddingTop: 0,
  },
  cardIndicators: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.spacing(2)}px`,
    '& > img': {
      width: 24,
    },
  },
  cardBottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.spacing(2) / 2}px ${theme.spacing(2)}px`,
  },
  cardPrice: {
    '& > span': {
      fontSize: theme.typography.pxToRem(12),
      color: variables.palette.primary.main,
      display: 'block',
      fontWeight: 500,
      textAlign: 'left',
    },
    '& > span + span': {
      fontSize: theme.typography.pxToRem(13),
      color: variables.palette.secondary.main,
      display: 'block',
      textAlign: 'left',
      fontWeight: 400,
    },
  },
  cardScore: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(14),
    color: variables.palette.primary.main,
    textAlign: 'right',
    '& > span': {
      color: '#FBCB41',
      marginLeft: theme.spacing(2) / 2,
    },
  },
  rpc: {
    textAlign: 'right',
    fontSize: theme.typography.pxToRem(14),
    color: variables.palette.primary.light,
    '& > span': {
      fontSize: theme.typography.pxToRem(12),
      color: variables.palette.primary.main,
      display: 'block',
    },
  },
}));

interface IProps extends DispatchProp<any> {
  classes?: any;
  data: any;
  newTab?: any;
}

class ProductCard extends React.Component<IProps> {
  render() {
    const { classes, data } = this.props;

    return (
      <a onClick={() => window.open(`${URL_SELECT}/product/details/${data.id}`)}>
        <div className={classes.cardContainer}>
          <div className={classes.cardImage}>
            <img src={data.image ? data.image : ''} alt='Product' />
          </div>
          <div className={classes.cardTitle}>
            <Truncate title={data.title} final={' '} count={34}>
              {data.title}
            </Truncate>
          </div>
          <div className={classes.cardAuthor}>
            <Truncate title={data.producer_name} final={' '} count={20}>
              {data.producer_name}
            </Truncate>
          </div>
          <div className={classes.cardIndicators}>
            <Tooltip placement='top' title={data.infinity_funnel ? 'Funil Infinito Ativo' : 'Funil Infinito Inativo'}>
              <img src={data.infinity_funnel ? '/img/icon_funil_ativo.png' : '/img/icon_funil.png'} alt='Icon' />
            </Tooltip>
            <Tooltip placement='top' title={data.sales_recovery ? 'Recuperação de Vendas Ativa' : 'Recuperação de Vendas Inativa'}>
              <img src={data.sales_recovery ? '/img/icon_recuperacao_ativo.png' : '/img/icon_recuperacao.png'} alt='Icon' />
            </Tooltip>
            {(data.has_subscription || data.charge_type === 'A') && (
              <Tooltip title='Possui cobrança recorrente' placement='top'>
                <div>
                  <MyIcon style={{ width: 24, display: 'flex', alignItems: 'center' }} name='icon-assinaturas' />
                </div>
              </Tooltip>
            )}
            {data.recruit === true && (
              <Tooltip title='Possui comissão de recrutamento' placement='top'>
                <img src='/img/icon_recruit.png' alt='Recruit' />
              </Tooltip>
            )}
            <Tooltip placement='top' title='RPC Produtor'>
              <div className={classes.rpc}>
                <span>RPC P</span>
                {data.rpc_producer !== 0 ? <FormattedNumber maximumFractionDigits={2} value={data.rpc_producer} /> : '-'}
              </div>
            </Tooltip>
            <Tooltip placement='top' title='RPC Afiliados'>
              <div className={classes.rpc}>
                <span>RPC A</span>
                {data.rpc_affiliate !== 0 ? <FormattedNumber maximumFractionDigits={2} value={data.rpc_affiliate} /> : '-'}
              </div>
            </Tooltip>
          </div>
          <div className={classes.cardBottom}>
            <div className={classes.cardPrice}>
              <span>Comissão:</span>
              <span>
                {data.showcase_subscription_commission &&
                  !data.showcase_subscription_commission.includes('R$ 0,00') &&
                  `${data.showcase_subscription_commission} rec.`}
              </span>
              <span>{data.showcase_commission && !data.showcase_commission.includes('R$ 0,00') && `${data.showcase_commission}`}</span>
            </div>
            <div className={classes.cardScore}>
              {data.rating !== '0' ? data.rating : '-'}
              <span>
                <Icon color='inherit'>star</Icon>
              </span>
            </div>
          </div>
        </div>
      </a>
    );
  }
}

export default connect()(styles(ProductCard));
